import { Chip } from "@mui/material";
import { TerminalInventoryStatus } from "Infrastructure/Api/Api";
import { useMemo } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Admin.Terminals.Status;

const STATUS_CHIP_COLORS: Record<
  TerminalInventoryStatus,
  "default" | "primary" | "secondary" | "info" | "warning" | "success" | "error"
> = {
  [TerminalInventoryStatus.InStock]: "default",
  [TerminalInventoryStatus.AssignedToHunter]: "info",
  [TerminalInventoryStatus.AssignedToMerchant]: "warning",
  [TerminalInventoryStatus.Shipped]: "primary",
  [TerminalInventoryStatus.WithMerchant]: "secondary",
  [TerminalInventoryStatus.Deployed]: "success",
  [TerminalInventoryStatus.Returned]: "error",
};

export const useTerminalStatusLabels = (): Record<
  TerminalInventoryStatus,
  string
> => {
  const { t } = useResource();

  return useMemo(
    () => ({
      [TerminalInventoryStatus.InStock]: t(RESOURCES.InStock),
      [TerminalInventoryStatus.AssignedToHunter]: t(RESOURCES.AssignedToHunter),
      [TerminalInventoryStatus.AssignedToMerchant]: t(
        RESOURCES.AssignedToMerchant,
      ),
      [TerminalInventoryStatus.Shipped]: t(RESOURCES.Shipped),
      [TerminalInventoryStatus.WithMerchant]: t(RESOURCES.WithMerchant),
      [TerminalInventoryStatus.Deployed]: t(RESOURCES.Deployed),
      [TerminalInventoryStatus.Returned]: t(RESOURCES.Returned),
    }),
    [t],
  );
};

type Props = {
  status: TerminalInventoryStatus;
};

export const TerminalStatusChip = ({ status }: Props) => {
  const statusLabels = useTerminalStatusLabels();

  return (
    <Chip
      label={statusLabels[status]}
      size="small"
      color={STATUS_CHIP_COLORS[status]}
    />
  );
};
